module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quoteReport"
  }, [(_vm.filterDrawer == true) ? _c('div', {
    staticStyle: {
      "z-index": "2",
      "opacity": "0.8",
      "background": "#000",
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "left": "0",
      "top": "42px"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "rightDrawer",
    attrs: {
      "right": "",
      "absolute": "",
      "light": "",
      "width": "1000"
    },
    model: {
      value: (_vm.filterDrawer),
      callback: function($$v) {
        _vm.filterDrawer = $$v
      },
      expression: "filterDrawer"
    }
  }, [(_vm.filterNeedsReload == true) ? _c('v-container', {
    ref: "filterReload"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading Filters"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReload == false) ? _c('v-container', {
    ref: "filterShow"
  }, [_c('v-layout', {
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg11": ""
    }
  }, [_c('h2', [_vm._v("FILTER YOUR REPORT")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCloseDrawer.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "regenReport",
    on: {
      "click": function($event) {
        return _vm.fncSearchNewQuotes(false, false, false)
      }
    }
  }, [_vm._v("REGENERATE REPORT")]), _vm._v(" "), _c('v-btn', {
    staticClass: "clearfilters",
    staticStyle: {
      "float": "left !important"
    },
    on: {
      "click": function($event) {
        return _vm.fncClearFilter()
      }
    }
  }, [_vm._v("CLEAR ALL FILTERS")]), _vm._v(" "), _c('v-btn', {
    staticClass: "clearregen",
    staticStyle: {
      "float": "left !important"
    },
    on: {
      "click": function($event) {
        return _vm.fncSearchClearNewQuotes()
      }
    }
  }, [_vm._v("CLEAR & REGENERATE")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.search != '') ? _c('small', {
    staticStyle: {
      "display": "block",
      "margin-top": "2px",
      "font-weight": "bold"
    }
  }, [_vm._v("You currently have search text which could affect your filters.")]) : _vm._e(), _vm._v(" "), _c('br'), _c('h3', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("DATE")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "dates",
    attrs: {
      "lg12": ""
    }
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "Start Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.reportDate[0]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 0, $$v)
      },
      expression: "reportDate[0]"
    }
  }), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true) ? _c('span', {
    staticClass: "toRep"
  }, [_vm._v("to")]) : _vm._e(), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "End Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.reportDate[1]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 1, $$v)
      },
      expression: "reportDate[1]"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.fncSetDateEmpty
    }
  }, [_vm._v("GO")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "or",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_vm._v("OR")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.quoteFilter != 99 && _vm.quoteFilter > 0) ? _c('v-select', {
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "14%",
      "margin-top": "-18px"
    },
    attrs: {
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncChangeQuotes('nonchange')
      }
    },
    model: {
      value: (_vm.quoteFilter),
      callback: function($$v) {
        _vm.quoteFilter = $$v
      },
      expression: "quoteFilter"
    }
  }) : _c('v-select', {
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "14%",
      "margin-top": "-18px"
    },
    attrs: {
      "label": _vm.fncFilterLabel(),
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncChangeQuotes('nonchange')
      }
    },
    model: {
      value: (_vm.quoteFilter),
      callback: function($$v) {
        _vm.quoteFilter = $$v
      },
      expression: "quoteFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "additional",
    attrs: {
      "lg12": ""
    }
  }, [_c('h3', [_vm._v("OTHER")]), _c('br')]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Vendor")])]), _vm._v(" "), (_vm.fncCheckDone('vendor')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "vendorSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('vendor'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('vendor')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('vendor')
      }
    },
    model: {
      value: (_vm.objVendor),
      callback: function($$v) {
        _vm.objVendor = $$v
      },
      expression: "objVendor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Store")])]), _vm._v(" "), (_vm.fncCheckDone('store')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "storeSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('store'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('store')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('store')
      }
    },
    model: {
      value: (_vm.objStore),
      callback: function($$v) {
        _vm.objStore = $$v
      },
      expression: "objStore"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Originator")])]), _vm._v(" "), (_vm.fncCheckDone('originator')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "originatorSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('originator'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('originator')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('originator')
      }
    },
    model: {
      value: (_vm.objOriginator),
      callback: function($$v) {
        _vm.objOriginator = $$v
      },
      expression: "objOriginator"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Customer")])]), _vm._v(" "), (_vm.fncCheckDone('customer')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "customerSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('customer'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('customer')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('customer')
      }
    },
    model: {
      value: (_vm.objCustomerUser),
      callback: function($$v) {
        _vm.objCustomerUser = $$v
      },
      expression: "objCustomerUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), (_vm.fncCheckDone('status')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "statusSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('status'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('status')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('status')
      }
    },
    model: {
      value: (_vm.objStatus),
      callback: function($$v) {
        _vm.objStatus = $$v
      },
      expression: "objStatus"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Departments")])]), _vm._v(" "), (_vm.fncCheckDone('department')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "departmentSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('department'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('department')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('department')
      }
    },
    model: {
      value: (_vm.objDepartment),
      callback: function($$v) {
        _vm.objDepartment = $$v
      },
      expression: "objDepartment"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("KAM Region")])]), _vm._v(" "), (_vm.fncCheckDone('region')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "regionSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('region'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('region')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('region')
      }
    },
    model: {
      value: (_vm.objRegion),
      callback: function($$v) {
        _vm.objRegion = $$v
      },
      expression: "objRegion"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Responsible Rep")])]), _vm._v(" "), (_vm.fncCheckDone('rep')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "repSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('rep'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('rep')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('rep')
      }
    },
    model: {
      value: (_vm.objRep),
      callback: function($$v) {
        _vm.objRep = $$v
      },
      expression: "objRep"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Quote Type")])]), _vm._v(" "), (_vm.fncCheckDone('quote_type')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "quoteTypeSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('quote_type'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('quote_type')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('quote_type')
      }
    },
    model: {
      value: (_vm.objQuoteType),
      callback: function($$v) {
        _vm.objQuoteType = $$v
      },
      expression: "objQuoteType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Service Type")])]), _vm._v(" "), (_vm.fncCheckDone('service_type')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "serviceTypeSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('service_type'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('service_type')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('service_type')
      }
    },
    model: {
      value: (_vm.objServiceType),
      callback: function($$v) {
        _vm.objServiceType = $$v
      },
      expression: "objServiceType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Projects")])]), _vm._v(" "), (_vm.fncCheckDone('projects')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "projectsSelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('projects'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('projects')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('projects')
      }
    },
    model: {
      value: (_vm.objProjects),
      callback: function($$v) {
        _vm.objProjects = $$v
      },
      expression: "objProjects"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Company")])]), _vm._v(" "), (_vm.fncCheckDone('company')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "companySelect",
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.fncSetFilters('company'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('company')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('company')
      }
    },
    model: {
      value: (_vm.objCompany),
      callback: function($$v) {
        _vm.objCompany = $$v
      },
      expression: "objCompany"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-content', {
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.quotesLoaded == false || _vm.editLoading == true) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true && _vm.editLoading == false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "daterow": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "xs3": "",
      "searchpanel": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true && _vm.editLoading == false),
      expression: "quoteReportLoaded == true && quotesLoaded == true && editLoading == false"
    }],
    ref: "searchQuoteField",
    staticClass: "quoteNumberSearchPanel",
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-right": "0px",
      "width": "380px"
    },
    attrs: {
      "append-icon": "search",
      "disabled": _vm.EnableSearchQuote,
      "label": _vm.fncQuoteSearchLabel(),
      "id": "quoteSearch",
      "value": _vm.searchQuoteReport,
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.CheckEditable
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1 == 2 && _vm.quoteReportLoaded == true && _vm.quotesLoaded == true && _vm.editLoading == false),
      expression: "1 == 2 && quoteReportLoaded == true && quotesLoaded == true && editLoading == false"
    }],
    ref: "searchField",
    staticClass: "quoteSearchPanel",
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-right": "0px",
      "width": "225px"
    },
    attrs: {
      "disabled": _vm.EnableSearch,
      "append-icon": "search",
      "label": _vm.fncSearchLabel(),
      "id": "quoteSearch",
      "value": _vm.search,
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.CheckEditableSearch
    }
  }), _vm._v(" "), (_vm.nonClickable == true && _vm.quoteReportLoaded == true && _vm.quotesLoaded == true && _vm.editLoading == false) ? _c('v-btn', {
    staticClass: "dashGenerateRep qtGenerate",
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important",
      "position": "absolute",
      "height": "35px",
      "margin-top": "3px",
      "display": "block",
      "right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.fncSearchNewQuotes()
      }
    }
  }, [_vm._v("SEARCH")]) : _vm._e(), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true && _vm.editLoading == false) ? _c('v-btn', {
    staticClass: "dashGenerateRep qtGenerate",
    staticStyle: {
      "background": "#333 !important",
      "color": "#fff !important",
      "position": "absolute",
      "margin-top": "3px",
      "display": "block",
      "right": "73px",
      "height": "35px"
    },
    on: {
      "click": function($event) {
        return _vm.fncClearSearchTop()
      }
    }
  }, [_vm._v("CLEAR")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "filterresetbtns": ""
    }
  }, [(_vm.quotesLoaded == true && _vm.filterDrawer == true) ? _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-top": "1px",
      "height": "39px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCloseDrawer.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Hide Filters")]) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReload == false && _vm.objAuthorize.type != '6' && _vm.quotesLoaded == true && _vm.filterDrawer == false) ? _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-top": "1px",
      "height": "39px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowFilterSlide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Filters")]) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReload == false && _vm.quotesLoaded == true && _vm.filterDrawer == false) ? _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-top": "1px",
      "height": "39px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncSearchClearNewQuotes()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")]), _vm._v("Clear Filters")]) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReload == true && _vm.objAuthorize.type != '6' && _vm.quotesLoaded == true && _vm.filterDrawer == false) ? _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-top": "1px",
      "height": "39px"
    },
    attrs: {
      "color": "info",
      "disabled": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowFilterSlide()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Loading Filters")]) : _vm._e(), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true && _vm.quotesLinked == true) ? _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "display": "block",
      "float": "left",
      "height": "39px",
      "margin-top": "1px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncHideLinkedQuotes()
      }
    }
  }, [_vm._v("Hide Linked Quotes")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "margin-top": "1px",
      "height": "39px"
    },
    attrs: {
      "color": "info reloadButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncSearchNewQuotes.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("refresh")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "datefilters": ""
    }
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "Start Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    on: {
      "mousedown": _vm.fncClearFilterShadows,
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.reportDate[0]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 0, $$v)
      },
      expression: "reportDate[0]"
    }
  }), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true) ? _c('span', {
    staticClass: "toRep"
  }, [_c('strong', [_vm._v("to")])]) : _vm._e(), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "End Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    on: {
      "mousedown": _vm.fncClearFilterShadows,
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.reportDate[1]),
      callback: function($$v) {
        _vm.$set(_vm.reportDate, 1, $$v)
      },
      expression: "reportDate[1]"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "margin-top": "1px"
    },
    attrs: {
      "color": "info",
      "disabled": _vm.checGoButton
    },
    on: {
      "click": function($event) {
        return _vm.fncSearchNewQuotes(true)
      }
    }
  }, [_vm._v("GO")]), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true) ? _c('span', {
    staticClass: "toRep"
  }, [_c('strong', [_vm._v("OR")])]) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "145px"
    },
    attrs: {
      "label": _vm.fncFilterLabel(),
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "change": function($event) {
        return _vm.fncOnrangeChange()
      },
      "mousedown": _vm.fncClearFilterShadows,
      "input": function($event) {
        return _vm.fncChangeQuotes(false, true)
      }
    },
    model: {
      value: (_vm.quoteFilter),
      callback: function($$v) {
        _vm.quoteFilter = $$v
      },
      expression: "quoteFilter"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') != -1) ? _c('div', {
    staticStyle: {
      "height": "80px !important"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') == -1 && _vm.quotesLoaded == true && _vm.editLoading == false) ? _c('v-tabs', {
    staticClass: "pt-4 mt-5",
    attrs: {
      "slider-color": "grey"
    },
    model: {
      value: (_vm.topTab),
      callback: function($$v) {
        _vm.topTab = $$v
      },
      expression: "topTab"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": "",
      "disabled": _vm.tabIsDisabled('is_initial_engagement_quote')
    },
    on: {
      "click": function($event) {
        return _vm.getTabs('is_initial_engagement_quote')
      }
    }
  }, [_vm._v("INITIAL ENGAGEMENT & QUOTING")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": "",
      "disabled": _vm.tabIsDisabled('is_negotiating_customer_approval')
    },
    on: {
      "click": function($event) {
        return _vm.getTabs('is_negotiating_customer_approval')
      }
    }
  }, [_vm._v("NEGOTIATING CUSTOMER APPROVAL\n")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": "",
      "disabled": _vm.tabIsDisabled('is_manufacturer_fulfilment')
    },
    on: {
      "click": function($event) {
        return _vm.getTabs('is_manufacturer_fulfilment')
      }
    }
  }, [_vm._v("MANUFACTURER & FULFILMENT")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": "",
      "disabled": _vm.tabIsDisabled('is_cancelled_expired_rejected')
    },
    on: {
      "click": function($event) {
        return _vm.getTabs('is_cancelled_expired_rejected')
      }
    }
  }, [_vm._v("CANCELLED, REJECTED OR EXPIRED")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticStyle: {
      "background-color": "white",
      "width": "98%"
    }
  }, [(_vm.quotesLoaded == true) ? _c('v-tabs', {
    staticClass: "pt-2 ",
    staticStyle: {
      "background-color": "white !important"
    },
    attrs: {
      "next-icon": "next-quote-status",
      "show-arrows": "",
      "prev-icon": "prev-quote-status",
      "row": "",
      "value": _vm.secondTab,
      "id": "subTab",
      "slider-color": "grey"
    },
    on: {
      "input": _vm.onTabSelected
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _vm._l((_vm.tabs.is_initial_engagement_quote), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      staticClass: "tab",
      class: [(_vm.secondTab === 'null' && _vm.fncCanApplyLeftBorder('is_initial_engagement_quote', tab.description)) ? 'tabs_left_border' : '',
        _vm.secondTab === 'null' ? 'tabs_borders' : '',
        (_vm.fncCanApplyRightBorder('is_initial_engagement_quote', tab.description) && _vm.secondTab === 'null') ? 'tabs_right_border' : ''
      ],
      attrs: {
        "id": "tab1",
        "value": tab.id,
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.getTab(tab.description)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
        "display": "-webkit-box"
      }
    }, [_vm._v(" " + _vm._s(tab.description))])])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticStyle: {
      "background-color": "white",
      "width": "98%"
    }
  }, [(_vm.quotesLoaded == true) ? _c('v-tabs', {
    staticClass: "pt-2 ",
    staticStyle: {
      "background-color": "white !important"
    },
    attrs: {
      "next-icon": "next-quote-status",
      "prev-icon": "prev-quote-status",
      "id": "subTab",
      "slider-color": "grey"
    },
    model: {
      value: (_vm.secondTab),
      callback: function($$v) {
        _vm.secondTab = $$v
      },
      expression: "secondTab"
    }
  }, _vm._l((_vm.tabs.is_negotiating_customer_approval), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      staticClass: "tab",
      class: [(_vm.secondTab === 'null' && _vm.fncCanApplyLeftBorder('is_negotiating_customer_approval', tab.description)) ? 'tabs_borders tabs_left_border' : '',
        _vm.secondTab === 'null' ? 'tabs_borders' : '',
        (_vm.fncCanApplyRightBorder('is_negotiating_customer_approval', tab.description) && _vm.secondTab === 'null') ? 'tabs_right_border' : ''
      ],
      attrs: {
        "id": "tab1",
        "value": tab.id,
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.getTab(tab.description)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
        "display": "-webkit-box"
      }
    }, [_vm._v(" " + _vm._s(tab.description))])])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticStyle: {
      "background-color": "white",
      "width": "98%"
    }
  }, [(_vm.quotesLoaded == true) ? _c('v-tabs', {
    staticClass: "pt-2 ",
    staticStyle: {
      "background-color": "white !important"
    },
    attrs: {
      "next-icon": "next-quote-status",
      "prev-icon": "prev-quote-status",
      "id": "subTab",
      "slider-color": "grey"
    },
    model: {
      value: (_vm.secondTab),
      callback: function($$v) {
        _vm.secondTab = $$v
      },
      expression: "secondTab"
    }
  }, _vm._l((_vm.tabs.is_manufacturer_fulfilment), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      staticClass: "tab",
      class: [(_vm.secondTab === 'null' && _vm.fncCanApplyLeftBorder('is_manufacturer_fulfilment', tab.description)) ? 'tabs_borders tabs_left_border' : '',
        _vm.secondTab === 'null' ? 'tabs_borders' : '',
        (_vm.fncCanApplyRightBorder('is_manufacturer_fulfilment', tab.description) && _vm.secondTab === 'null') ? 'tabs_right_border' : ''
      ],
      attrs: {
        "id": "tab1",
        "value": tab.id,
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.getTab(tab.description)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
        "display": "-webkit-box"
      }
    }, [_vm._v(" " + _vm._s(tab.description))])])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticStyle: {
      "background-color": "white",
      "width": "98%"
    }
  }, [(_vm.quotesLoaded == true) ? _c('v-tabs', {
    staticClass: "pt-2 ",
    staticStyle: {
      "background-color": "white !important"
    },
    attrs: {
      "next-icon": "next-quote-status",
      "prev-icon": "prev-quote-status",
      "id": "subTab",
      "slider-color": "grey"
    },
    model: {
      value: (_vm.secondTab),
      callback: function($$v) {
        _vm.secondTab = $$v
      },
      expression: "secondTab"
    }
  }, _vm._l((_vm.tabs.is_cancelled_expired_rejected), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      staticClass: "tab",
      class: [(_vm.secondTab === 'null' && _vm.fncCanApplyLeftBorder('is_cancelled_expired_rejected', tab.description)) ? 'tabs_borders tabs_left_border' : '',
        _vm.secondTab === 'null' ? 'tabs_borders' : '',
        (_vm.fncCanApplyRightBorder('is_cancelled_expired_rejected', tab.description) && _vm.secondTab === 'null') ? 'tabs_right_border' : ''
      ],
      attrs: {
        "id": "tab1",
        "value": tab.id,
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.getTab(tab.description)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "-webkit-line-clamp": "2",
        "-webkit-box-orient": "vertical",
        "display": "-webkit-box"
      }
    }, [_vm._v(" " + _vm._s(tab.description))])])
  }), 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.quotesLoaded == true && (_vm.headers.length <= 2 || _vm.quoteSearchList.length == 0)) ? _c('p', {
    staticClass: "pt-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _c('strong', [_vm._v(" No matching records found.")])]) : _vm._e(), _vm._v(" "), (_vm.quotesLoaded == true && _vm.editLoading == false && _vm.headers.length > 2 && _vm.quoteSearchList.length > 0) ? _c('div', {
    staticClass: "paginationRecords pt-3 pl-3",
    domProps: {
      "innerHTML": _vm._s(_vm.fncShowPaginationRecords())
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1 && _vm.quotesLoaded == true && _vm.editLoading == false && _vm.headers.length > 2 && _vm.quoteSearchList.length > 0) ? _c('v-pagination', {
    attrs: {
      "length": this.totalPages,
      "page": this.getPage,
      "total-visible": 7
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.quotesLoaded == true && _vm.editLoading == false && _vm.headers.length > 2 && _vm.quoteSearchList.length > 0) ? _c('div', {
    class: _vm.fncHasFilters(),
    staticStyle: {
      "width": "100%",
      "overflow": "auto"
    },
    attrs: {
      "id": "quoteReportTable"
    }
  }, [((_vm.quotesLoaded == true && _vm.quoteReportLoaded == true) || _vm.search != '') ? _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    style: ({
      'width': _vm.tableWidth + 'px'
    }),
    attrs: {
      "headers": _vm.headers,
      "items": _vm.quoteSearchList,
      "disable-initial-sort": "",
      "total-items": _vm.fncGetRecordCount(),
      "rows-per-page-items": [50]
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(row) {
        return [_c('tr', _vm._l((_vm.headers), function(header) {
          return _c('th', {
            staticClass: "reportFilters",
            attrs: {
              "valign": "top",
              "width": header.width,
              "data-ref": header.value
            },
            on: {
              "click": function($event) {
                return _vm.fncShowFilterPop(header.text)
              }
            }
          }, [_c('span', {
            staticClass: "headerTitle",
            staticStyle: {
              "pointer-events": "none"
            }
          }, [(header.text == 'Discount Value' || header.text == 'Pre-Discount Total' || header.text == 'Sub-Total' || header.text == 'VAT' || header.text == 'Total') ? _c('div', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s(_vm.fncUpper(header.text)))]) : _vm._e(), _vm._v(" "), (header.text == 'Responsible Rep' || header.text == 'Users Linked to Quote') ? _c('div', [_vm._v("Users Linked to Quote")]) : _vm._e(), _vm._v(" "), (header.text == 'User Type' || header.text == 'Customer User Type') ? _c('div', [_vm._v("Customer User Type")]) : _vm._e(), _vm._v(" "), (header.text != 'User Type' && header.text != 'Customer User Type' && header.text != 'Responsible Rep' && header.text != 'Users Linked to Quote' && header.text != 'Discount Value' && header.text != 'Pre-Discount Total' && header.text != 'Sub-Total' && header.text != 'VAT' && header.text != 'Total') ? _c('div', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncCheckHeaderFilter(header.text))
            }
          }) : _vm._e(), _vm._v(" "), (_vm.dateFilterShow == true && header.text == 'Quote Date') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowDateFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.vendorFilterShow == true && header.text == 'Vendor') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowVendorFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.departmentFilterShow == true && header.text == 'Department') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowDepartmentFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.storeFilterShow == true && header.text == 'Store') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowStoreFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.originatorFilterShow == true && header.text == 'Originator Name') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowOriginatorFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.customerFilterShow == true && header.text == 'Customer Name') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowCustomerUserFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.statusFilterShow == true && header.text == 'Status') ? _c('div', {
            staticClass: "reportFilterPop"
          }) : _vm._e(), _vm._v(" "), (_vm.regionFilterShow == true && header.text == 'Kam Region') ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowRegionFilters())
            }
          }) : _vm._e(), _vm._v(" "), (_vm.repFilterShow == true && (header.text == 'Responsible Rep' || header.text == 'Users Linked to Quote')) ? _c('div', {
            staticClass: "reportFilterPop",
            domProps: {
              "innerHTML": _vm._s(_vm.fncShowRepFilters())
            }
          }) : _vm._e()])])
        }), 0)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return (_vm.fncCanDisplay(props.item)) ? [_c('td', {
          staticClass: "menu-field",
          style: ({
            'border-left': '6px solid ' + props.item.backgroundColour + ' !important'
          })
        }, [_c('v-menu', {
          attrs: {
            "offset-y": ""
          }
        }, [_c('i', {
          staticClass: "material-icons menuIcon",
          staticStyle: {
            "color": "#00a99d"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("menu")]), _vm._v(" "), _c('v-list', [(_vm.fncCheckTalisman(props.item.departmentId)) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewQuote(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("View Quote Details")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDownloadQuotePdf(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Download Quote PDF")])])], 1), _vm._v(" "), (_vm.fncCheckSurveyDocument(props.item)) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditSurveyDoc(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit Service Form Document")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckSurveyDocument(props.item)) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncCloneQuote(props.item.id, props.item.departmentId)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Clone Quote")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckSurveyDocument(props.item)) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDownloadSurveyDoc(props.item.id, props.item.quote_no, 'full')
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Download Service Form Document - Full")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckSurveyDocument(props.item)) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDownloadSurveyDoc(props.item.id, props.item.quote_no, 'client')
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Download Service Form Document - Client")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckSalesOrder(props.item)) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDownloadPdf(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Download Sales Order")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncLinkedQuotes(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("View Linked Quotes")])])], 1), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncNotificationHistory(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Notification History")])])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf("CAN_ARCHIVE") != -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncArchiveQuote(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Archive Quote")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.objAuthorize.email == 'superuser@ndtec.co.za' || _vm.objAuthorize.email == 'bwsuperuser@ndtec.co.za') && _vm.objAuthorize.manufacturer == '385889803') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRefreshQuoteNo(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Refresh Quote Number")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncStoreAudits(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("View Store Change Audits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_UPDATE_STORE') != -1 && _vm.objAuthorize.manufacturer == '385889803') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncUpdateStore(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Update Store")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_VIEW_API_AUDITS') != -1 && _vm.objAuthorize.manufacturer == '385889803') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewApis(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("View API Audits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewDeliveryNote(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Download Delivery Note")])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803' && _vm.fncDepartmentCanEdit(props.item)) ? _c('a', {
          staticClass: "menu editQuoteIcon",
          attrs: {
            "title": "Edit Quote"
          },
          on: {
            "click": function($event) {
              return _vm.fncEditQuote(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons menuIcon",
          staticStyle: {
            "color": "#00a99d"
          }
        }, [_vm._v("edit")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803' && _vm.fncCheckSurveyDocument(props.item) && _vm.fncCheckCalcItems(props.item)) ? _c('a', {
          staticClass: "menu openCalcIcon",
          attrs: {
            "title": "Open Calculators"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenCalc(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons menuIcon",
          staticStyle: {
            "color": "#00a99d"
          }
        }, [_vm._v("calculate")])]) : _vm._e()], 1), _vm._v(" "), (_vm.objAuthorize.vendorActive == 1 && _vm.objAuthorize.type != '6') ? _c('td', {
          staticClass: "nowrap vendorName",
          attrs: {
            "width": "350px"
          }
        }, [(props.item.vendorName != 'None') ? _c('span', [_vm._v(_vm._s(props.item.vendorName))]) : _c('span', [_vm._v(_vm._s(props.item.vendorName))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.objQuoteSettings), function(item) {
          return (_vm.fncCheckSubDisplay(item)) ? _c('td', {
            attrs: {
              "width": _vm.fncGetWidth(item.id)
            }
          }, [(item.id == 'linkedQuotes') ? _c('span', {
            staticClass: "pencil nowrap",
            domProps: {
              "innerHTML": _vm._s(_vm.fncFormatColumn(props.item, item.id))
            },
            on: {
              "click": _vm.fncRunQuoteSearch
            }
          }) : _vm._e(), _vm._v(" "), (item.id != 'linkedQuotes' && item.id != 'quote_no' && item.id != 'status' && item.id != 'orig_name') ? _c('span', {
            staticClass: "pencil nowrap",
            domProps: {
              "innerHTML": _vm._s(_vm.fncFormatColumn(props.item, item.id))
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncEditStatus(props.item, item.id)
              }
            }
          }) : _vm._e(), _vm._v(" "), (item.id != 'linkedQuotes' && item.id != 'quote_no' && item.id == 'orig_name' && _vm.canEditOriginator == false) ? _c('span', {
            staticClass: "pencil nowrap",
            domProps: {
              "innerHTML": _vm._s(_vm.fncFormatColumn(props.item, item.id))
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncEditStatus(props.item, item.id)
              }
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "nowrap status-container"
          }, [(item.id == 'status') ? _c('span', {
            staticClass: "status-text"
          }, [_c('strong', {
            attrs: {
              "id": _vm.fncSetId(props.item.id)
            }
          }, [_vm._v(_vm._s(props.item.status))])]) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReload == false && _vm.objAuthorize.privileges.indexOf('CANNOT_UPDATE_STATUS') == -1 && !_vm.fncCheckStatusStatus(props.item) && item.id == 'status') ? _c('span', {
            on: {
              "click": function($event) {
                return _vm.fncEditStatusPopup(props.item, props.item.id)
              }
            }
          }, [_c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            }
          }, [_vm._v("UPDATE STATUS")])], 1) : _vm._e(), _vm._v(" "), (_vm.filterNeedsReload == false && item.id == 'status') ? _c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncEditStatus(props.item, 'status')
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("history")])]) : _vm._e()]), _vm._v(" "), (item.id == 'orig_name' && _vm.canEditOriginator == true) ? _c('v-select', {
            staticClass: "statusList originatorDropdown",
            staticStyle: {
              "width": "87%",
              "display": "block",
              "float": "left",
              "margin-top": "0px !important"
            },
            attrs: {
              "label": props.item.orig_name,
              "item-value": "id",
              "items": _vm.repUsers,
              "item-text": "label",
              "solo": "",
              "outline": "",
              "autocomplete": ""
            },
            on: {
              "input": function($event) {
                return _vm.fncEditOriginator(props.item)
              }
            },
            model: {
              value: (props.item.originator),
              callback: function($$v) {
                _vm.$set(props.item, "originator", $$v)
              },
              expression: "props.item.originator"
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "nowrap responsibleRep"
          }, [(item.id == 'responsible_representative' && _vm.objAuthorize.manufacturer != '1845509583') ? _c('span', [_vm._v(_vm._s(_vm.fncShowReps(props.item.responsible_representative, [])))]) : _vm._e(), _vm._v(" "), (item.id == 'responsible_representative' && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleReps(props.item, 0)
              }
            },
            slot: "activator"
          }, [_vm._v("UPDATE")]) : _vm._e()], 1), _vm._v(" "), (item.id == 'customerRecipient') ? _c('span', {
            staticClass: "nowrap customerRecipient"
          }, [(props.item.customer_recipient != '') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncDotDotDot(props.item.customer_recipient))
            }
          }) : _c('span', [_vm._v("Not Set")]), _vm._v(" "), _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncEditCustomerRecipient(props.item)
              }
            }
          }, [_vm._v("UPDATE")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'vendorRecipient') ? _c('span', {
            staticClass: "nowrap vendorRecipient",
            staticStyle: {
              "margin-top": "2px",
              "display": "block",
              "padding-top": "0px",
              "padding-right": "4px",
              "padding-bottom": "0px"
            }
          }, [(props.item.vendor_recipient != '') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncDotDotDot(props.item.vendor_recipient))
            }
          }) : _c('span', [_vm._v("Not Set")]), _vm._v(" "), _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncEditVendorRecipient(props.item)
              }
            }
          }, [_vm._v("UPDATE")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "responsibleRep nowrap"
          }, [(item.id == 'commercialKam' && _vm.objAuthorize.manufacturer == '385889803') ? _c('span', [_c('br'), _vm._v(_vm._s(props.item.responsible_kam_name))]) : _vm._e(), _vm._v(" "), (item.id == 'commercialKam' && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleKams(props.item)
              }
            },
            slot: "activator"
          }, [_vm._v("SET")]) : _vm._e(), _vm._v(" "), (item.id == 'commercialOriginator' && _vm.objAuthorize.manufacturer == '385889803') ? _c('span', [_vm._v(_vm._s(props.item.responsible_originator_name))]) : _vm._e(), _vm._v(" "), (item.id == 'commercialOriginator' && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleOriginator(props.item)
              }
            },
            slot: "activator"
          }, [_vm._v("SET")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
            staticClass: "responsibleRep nowrap"
          }, [(!isNaN(item.id)) ? _c('span', [_vm._v(_vm._s(_vm.fncShowRepsSub(props.item.responsible_representative, item)))]) : _vm._e(), _vm._v(" "), (!isNaN(item.id) && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleReps(props.item, item.id)
              }
            },
            slot: "activator"
          }, [_vm._v("UPDATE")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
            staticClass: "nowrap reportAttachmentContainer"
          }, [(item.id == 'quote_no' && props.item.hasAttachments != '0') ? _c('a', {
            staticClass: "reportAttachment",
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncQuoteSettings(props.item.id, props.item.quote_no, props.item)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons attachmentTick",
            staticStyle: {
              "font-size": "6px !important",
              "top": "-18px",
              "left": "-5px !important"
            }
          }, [_vm._v("done")]), _c('i', {
            staticClass: "material-icons",
            staticStyle: {
              "position": "relative",
              "left": "-16px"
            }
          }, [_vm._v("attach_file")])]) : _vm._e(), _vm._v(" "), (item.id == 'quote_no' && props.item.hasAttachments == '0') ? _c('a', {
            staticClass: "reportAttachment",
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncQuoteSettings(props.item.id, props.item.quote_no, props.item)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons",
            staticStyle: {
              "opacity": "1"
            }
          }, [_vm._v("attach_file")])]) : _vm._e(), _vm._v(" "), (item.id == 'quote_no' && props.item.hasAttachments != '0') ? _c('span', [_c('strong', [_vm._v(_vm._s(props.item.quote_no))])]) : _vm._e(), _vm._v(" "), (item.id == 'quote_no' && props.item.hasAttachments == '0') ? _c('span', [_c('strong', [_vm._v(_vm._s(props.item.quote_no))])]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "nowrap processOrder"
          }, [(_vm.fncCheckProcessButton(props.item) && item.id == 'process_order') ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncGoSaleOrder(props.item)
              }
            }
          }, [_vm._v("Process Order")]) : _vm._e(), _vm._v(" "), (!_vm.fncCheckProcessButton(props.item) && item.id == 'process_order') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncCheckProcessButtonText(props.item))
            }
          }) : _vm._e()], 1), _vm._v(" "), (item.id == 'installationDate') ? _c('div', {
            staticClass: "nowrap dateInstallation"
          }, [(_vm.fncGetInstallationDate(props.item) === 'N/A') ? _c('span', {
            attrs: {
              "id": 'installation_date_' + props.item.id
            },
            domProps: {
              "innerHTML": _vm._s(_vm.fncGetInstallationDate(props.item))
            }
          }) : _vm._e(), _vm._v(" "), (_vm.fncGetInstallationDate(props.item) !== 'N/A') ? _c('date-picker', {
            staticClass: "quoteDateRep dashDateRep",
            staticStyle: {
              "min-width": "155px !important"
            },
            attrs: {
              "confirm": "",
              "type": "datetime",
              "value": _vm.dates[props.item.id],
              "format": "YYYY-MM-DD HH:mm",
              "minute-step": 30,
              "placeholder": "Installation Date",
              "lang": "en"
            },
            on: {
              "change": function($event) {
                return _vm.handleChange($event, props.item, 'installation')
              },
              "dateSelect": _vm.handleDateSelect
            }
          }) : _vm._e(), _vm._v(" "), _c('span', {
            staticStyle: {
              "padding-left": "6px",
              "padding-right": "140px"
            }
          }, [(_vm.fncGetInstallationDate(props.item) !== 'N/A') ? _c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncShowDateHistory(props.item, 'installation_date_change')
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("history")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.id == 'manufacturer_date_api') ? _c('div', {
            staticClass: "nowrap dateInstallation"
          }, [_c('date-picker', {
            staticClass: "quoteDateRep dashDateRep",
            staticStyle: {
              "min-width": "120px !important"
            },
            attrs: {
              "valueType": "format",
              "format": "YYYY-MM-DD",
              "minute-step": 01,
              "placeholder": "Manufacturer Date",
              "lang": "en"
            },
            on: {
              "change": function($event) {
                return _vm.handleChange($event, props.item, 'manufacturer')
              }
            },
            model: {
              value: (props.item.manufacturer_date_api),
              callback: function($$v) {
                _vm.$set(props.item, "manufacturer_date_api", $$v)
              },
              expression: "props.item.manufacturer_date_api"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "padding-left": "6px",
              "padding-right": "92px",
              "width": "140px"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncShowDateHistory(props.item, 'manufacturer_date_change')
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("history")])])])], 1) : _vm._e(), _vm._v(" "), (item.id === 'delivery_date_api') ? _c('div', {
            staticClass: "nowrap dateInstallation"
          }, [_c('date-picker', {
            staticClass: "quoteDateRep dashDateRep",
            staticStyle: {
              "min-width": "120px !important"
            },
            attrs: {
              "value": _vm.convertedItems[props.item.id],
              "valueType": "format",
              "format": "YYYY-MM-DD",
              "placeholder": "Delivery Date",
              "lang": "en"
            },
            on: {
              "change": function($event) {
                return _vm.handleChange($event, props.item, 'delivery_date_api')
              }
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "padding-left": "6px",
              "padding-right": "140px"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncShowDateHistory(props.item, 'delivaery_date_change')
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("history")])])])], 1) : _vm._e()], 1) : _vm._e()
        })] : undefined
      }
    }], null, true)
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}